import { CALL_API } from '../../../middlewares/api';
import { makeActionCreator } from '../../../utils/actionsUtils';
import { HTTP_METHOD_PUT } from '../../../constants/httpMethod';
import {
    REFRESH_TOKEN_REQUEST,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_FAILURE
} from './constants';

export const refreshTokenSuccess = makeActionCreator(REFRESH_TOKEN_SUCCESS);
export const refreshTokenFailure = makeActionCreator(REFRESH_TOKEN_FAILURE);

/**
 * Execute un appel AJAX vers le serveur pour faire une demande de login
 * Envoie au serveur le username et le password du membre
 * @param {*JSON} creds les identifiants de connexion du membre, {username: 'michel', password: 'azerty'}
 * @param {function} callback fonction executé lorsque le login à réussit
 */

export const resfreshUserToken = () => {
    return {
        [CALL_API]: {
            endpoint: '/auth/refresh',
            method: HTTP_METHOD_PUT,
            types: [REFRESH_TOKEN_REQUEST, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_FAILURE],
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/refresh/actions.js